/* eslint-disable camelcase */
import { NotificationRequestTypes } from './types';

interface NotificationProps {
  read?: number;
  id?: number;
  per_page?: number;
  page?: number;
}

export const setAsRead = ({ id }: NotificationProps) => ({
  types: [
    NotificationRequestTypes.READ_NOTIFICATION_REQUEST,
    NotificationRequestTypes.READ_NOTIFICATION_SUCCESS,
    NotificationRequestTypes.READ_NOTIFICATION_FAILURE,
  ],
  rest: id,
  promise: (client: any) => client.patch(`/notification/notifications/${id}`),
});

export const getAllUnreadNotificationsUpdatedBiddings = (params: NotificationProps) => ({
  types: [
    NotificationRequestTypes.UPDATE_BIDDINGS_REQUEST,
    NotificationRequestTypes.UPDATE_BIDDINGS_SUCCESS,
    NotificationRequestTypes.UPDATE_BIDDINGS_FAILURE,
  ],
  promise: (client: any) => client.get('/notification/updated_biddings.json?', { params }),
});

export const getAllUnreadNotificationsManagementBiddings = (params: NotificationProps) => ({
  types: [
    NotificationRequestTypes.SHOW_REQUEST,
    NotificationRequestTypes.SHOW_SUCCESS,
    NotificationRequestTypes.SHOW_FAILURE,
  ],
  promise: (client: any) => client.get('/notification/management_biddings.json?', { params }),
});

export const getAllUnreadNotificationsCampaigns = (params: NotificationProps) => ({
  types: [
    NotificationRequestTypes.SHOW_REQUEST,
    NotificationRequestTypes.SHOW_SUCCESS,
    NotificationRequestTypes.SHOW_FAILURE,
  ],
  promise: (client: any) => client.get('/notification/campaigns.json?', { params }),
});

export const getAllUnreadNotificationsDocuments = (params: NotificationProps) => ({
  types: [
    NotificationRequestTypes.SHOW_REQUEST,
    NotificationRequestTypes.SHOW_SUCCESS,
    NotificationRequestTypes.SHOW_FAILURE,
  ],
  promise: (client: any) => client.get('/notification/documents.json?', { params }),
});
